// src/services/projectsService.js
import apiClient from './api.js';

class ProjectsService {
  // Get all projects with filtering and pagination
  async getProjects(params = {}) {
    try {
      const response = await apiClient.get('/projects', params);
      return response;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  }

  // Get single project by ID
  async getProject(id) {
    try {
      const response = await apiClient.get(`/projects/${id}`);
      return response;
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  }

  // Create new project
  async createProject(projectData) {
    try {
      const response = await apiClient.post('/projects', projectData);
      return response;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  }

  // Update existing project
  async updateProject(id, projectData) {
    try {
      const response = await apiClient.put(`/projects/${id}`, projectData);
      return response;
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  }

  // Delete project
  async deleteProject(id) {
    try {
      const response = await apiClient.delete(`/projects/${id}`);
      return response;
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  }

  // Clone project
  async cloneProject(id) {
    try {
      const response = await apiClient.post(`/projects/${id}/clone`);
      return response;
    } catch (error) {
      console.error('Error cloning project:', error);
      throw error;
    }
  }
}

// Create singleton instance
const projectsService = new ProjectsService();

export default projectsService;